import { Skeleton } from "@mui/material";
import React from "react";
import styled from "styled-components";

export const LoadingCoverages = (): React.ReactElement => {
  return (
    <LoadingWrapper>
      <Skeleton variant="rounded" />
      <Skeleton variant="rounded" />
      <Skeleton variant="rounded" />
    </LoadingWrapper>
  );
};

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacer-s);
  margin-top: var(--spacer-xs);

  span {
    height: 150px;
  }

  @media screen and (min-width: 768px) {
    span {
      height: 122px;
    }
  }
`;
